import { HttpClient, HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { DebugElement, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Api {
  private headers = new HttpHeaders({
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  });

  private headers2 = new HttpHeaders({
    'Accept': 'application/json, text/plain, */*',
  });

  constructor(public http: HttpClient) {}

  setAuthToken(token: string): void {
    this.headers = this.headers.set('Authorization', `Bearer ${token}`);
  }

  get(endpoint: string, params?: any): Observable<any> {
    let reqOpts = new HttpParams();
    if (params) {
      for (let k in params) {
        if (params[k] !== undefined && params[k] !== null) {
          reqOpts = reqOpts.set(k, params[k]);
        }
      }
    }

    return this.http.get<any>(environment.baseUrl + endpoint, {
      headers: this.headers,
      params: reqOpts
    });
  }

  getGenerate<T>(endpoint: string, params?: any): Observable<HttpResponse<T>> {
    let reqOpts = new HttpParams();
    if (params) {
      for (let k in params) {
        if (params[k] !== undefined && params[k] !== null) {
          reqOpts = reqOpts.set(k, params[k]);
        }
      }
    }

    return this.http.get<T>(environment.baseUrl + endpoint, {
      headers: this.headers,
      params: reqOpts,
      observe: 'response'
    });
  }

  post(endpoint: string, body: any): Observable<any> {
    return this.http.post<any>(environment.baseUrl + endpoint, body, {
      headers: this.headers
    });
  }
  postText(endpoint: string, body: any): Observable<string> {
  return this.http.post(environment.baseUrl + endpoint, body, {
    headers: this.headers,
    responseType: 'text' as const
  });
}


  postGenerate<T>(endpoint: string, body: any): Observable<T> {
    return this.http.post<T>(environment.baseUrl + endpoint, body, {
      headers: this.headers
    });
  }

  postGenerateFile<T>(
    endpoint: string,
    body: any,
    options?: {
      headers?: HttpHeaders;
      reportProgress?: boolean;
      observe?: 'body' | 'response';
    }
  ): Observable<T> {
    const isFormData = body instanceof FormData;

    return this.http.post<T>(environment.baseUrl + endpoint, body, {
      reportProgress: options?.reportProgress,
      observe: options?.observe as 'body'
    });
  }


  putGenerate<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(environment.baseUrl + endpoint, body, {
      headers: this.headers
    });
  }

  patch(endpoint: string, body: any): Observable<any> {
    return this.http.patch<any>(environment.baseUrl + endpoint, body, {
      headers: this.headers
    });
  }

  patchGenerate<T>(endpoint: string, body: any): Observable<T> {
    return this.http.patch<T>(environment.baseUrl + endpoint, body, {
      headers: this.headers
    });
  }

  delete<T>(endpoint: string, id?: number): Observable<T> {
    const url = id ? `${environment.baseUrl}${endpoint}/${id}` : `${environment.baseUrl}${endpoint}`;
    return this.http.delete<T>(url, {
      headers: this.headers
    });
  }

  deleteWithBody<T>(endpoint: string, body: any): Observable<T> {
    return this.http.request<T>('DELETE', `${environment.baseUrl}${endpoint}`, {
      headers: this.headers,
      body
    });
  }
    getAll<T>(endpoint: string, params?: any): Observable<HttpResponse<T[]>> {
    let reqOpts = new HttpParams();
    if (params) {
      for (const k of Object.keys(params)) {
        if (params[k] !== undefined && params[k] !== null) {
          reqOpts = reqOpts.set(k, params[k]);
        }
      }
    }

    return this.http.get<T[]>(
      `${environment.baseUrl}${endpoint}`,
      {
        headers: this.headers,
        params: reqOpts,
        observe: 'response'
      }
    );
  }
}